export default __webpack_public_path__ + "3595d7c6688764b968aaea382c9ecfa5.svg";